<mat-toolbar class="text-uppercase">
  <mat-toolbar-row>
    <span>Usuários</span>
    <span class="spacer"></span>
    <button
      mat-raised-button
      color="primary"
      data-cy="export"
      (click)="exportUsers()"
      class="export"
    >
      Exportar
    </button>
    <button
      mat-raised-button
      color="primary"
      data-cy="new"
      (click)="openUser()"
    >
      Novo
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-accordion>
  <form #thisForm="ngForm">
    <mat-card>
      <mat-card-header> </mat-card-header>
      <mat-card-content class="container-fluid">
        <div class="row mb-2">
          <div class="col-12 external-user">
            <mat-checkbox [(ngModel)]="isExternalUser" name="externalUser"
              >Usuário Externo</mat-checkbox
            >
          </div>
        </div>
        <div class="row mb-2" *ngIf="isExternalUser === true">
          <div class="col-12">
            <mat-form-field>
              <input
                type="text"
                matInput
                placeholder="Gestora"
                [(ngModel)]="selectedAccManager"
                name="accountManager"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="getAccountManagerName"
              >
                <mat-option *ngFor="let item of accountManagers" [value]="item"
                  >{{ item.document + " " + item.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-4">
            <mat-form-field>
              <input
                type="text"
                matInput
                placeholder="Grupo"
                [(ngModel)]="selectedGroup"
                name="group"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="getGroupName"
              >
                <mat-option *ngFor="let item of groupList" [value]="item">
                  {{ item.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="Nome do Usuário"
                [(ngModel)]="nomeUsuario"
                name="nomeUsuario"
              />
            </mat-form-field>
          </div>
          <div class="col-2">
            <button
              mat-raised-button
              color="primary"
              class="filter-button"
              type="submit"
              (click)="clearFilters()"
            >
              Limpar
            </button>
          </div>
          <div class="col-2">
            <button
              mat-raised-button
              color="primary"
              class="filter-button"
              (click)="getUsers()"
            >
              Filtrar
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
</mat-accordion>

<table mat-table [dataSource]="model" class="usuarios">
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let user" class="actions">
      <fa-icon
        id="user-{{ user.id }}-id"
        [icon]="faListAlt"
        (click)="openUser(user.id)"
      ></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Nome</th>
    <td mat-cell *matCellDef="let user">{{ user.name }}</td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>E-mail</th>
    <td mat-cell *matCellDef="let user">{{ user.email }}</td>
  </ng-container>

  <ng-container matColumnDef="userName">
    <th mat-header-cell *matHeaderCellDef>Login</th>
    <td mat-cell *matCellDef="let user">{{ user.userName }}</td>
  </ng-container>

  <ng-container matColumnDef="groupNames">
    <th mat-header-cell *matHeaderCellDef>Grupos</th>
    <td mat-cell *matCellDef="let user">{{ user.groupNames }}</td>
  </ng-container>

  <ng-container matColumnDef="passwordExpirationDate">
    <th mat-header-cell *matHeaderCellDef>Validade da Senha</th>
    <td mat-cell *matCellDef="let user">{{ user.passwordExpirationDate }}</td>
  </ng-container>

  <ng-container matColumnDef="active">
    <th mat-header-cell *matHeaderCellDef>Ativo</th>
    <td mat-cell *matCellDef="let user">{{ user.active ? "Sim" : "Não" }}</td>
  </ng-container>

  <ng-container matColumnDef="lockoutEnabled">
    <th mat-header-cell *matHeaderCellDef>Bloqueado</th>
    <td mat-cell *matCellDef="let user">
      {{ user.lockoutEnabled ? "Sim" : "Não" }}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<paginador
  [listedPages]="listedPages"
  [firstItemOnPage]="firstItemOnPage"
  [lastItemOnPage]="lastItemOnPage"
  [totalPages]="totalPages"
  [totalItems]="totalItems"
  [itemsPerPage]="[10, 25, 50, 100]"
  [currentPage]="currentPage"
  (onSearch)="getUsers($event[0], $event[1])"
></paginador>
